export const SET_TOKEN = 'SET_TOKEN' // 设置token
export const CLEAR_TOKEN = 'CLEAR_TOKEN' // 清除token
